<!--
 - Author : wanghongling.
 - Date   : 2018/10/17.
 - File   : line.折线图
 -->

<template>
  <div :id="id" :style="{width: '100%', height: lineList.height, margin: lineList.margin}">
  </div>
</template>

<script>
export default {
  name: 'my-line',
  data() {
    return {
      position: this.lineList.position || ''
      // arrList: JSON.parse(window.localStorage.getItem('ecList'))
    }
  },
  props: {
    id: {
      type: String,
      default: 'test'
    },
    lineList: {},
    needSelfStyle: false,
    toolType: false
  },
  watch: {
    lineList: {
      handler() {
        this.$nextTick(() => {
          // window.removeEventListener('resize', this.resizeEvent)
          this.makeLine()
        })
      },
      deep: true
    }
  },
  mounted() {
    this.init()
    // let that = this
    /**
     * @Description:折线tooltip添加点击事件
     * @author wanghongling
     * @createDate 2019/9/24
     */
    // this.myLine.on('legendselectchanged', function (params) {
    //   let option = this.getOption()
    //   let selectValue = Object.values(params.selected)
    //   // that.lineList.list.data = []
    //   if (that.arrList) {
    //     selectValue.map((res, i) => {
    //       if (!res) {
    //         that.lineList.list.data[i] = []
    //       } else {
    //         that.lineList.list.data[i] = that.arrList[i]
    //       }
    //     })
    //   }
    //   this.setOption(option)
    // })
  },
  destroyed() {
    this.$echarts.dispose(this.myLine)
    // window.removeEventListener('resize', this.resizeEvent)
    this.myLine = null
  },
  methods: {
    /**
     * 初始化echart
     * @author: whl
     * @createDate: 2019/8/9
     * @return {Object}
     */
    init() {
      this.myLine = this.$echarts.init(document.getElementById(this.id))
      this.makeLine()
    },
    /**
     * echart赋值
     * @author: whl
     * @createDate: 2019/8/9
     * @return {Object}
     */
    makeLine() {
      let series = []
      let item = {}
      let nameList = []
      let areaStyle = {}
      let list = this.lineList.list.data
      for (let i = 0; i < list.length; i++) {
        if (this.lineList.opacity === 0) {
          areaStyle = {
            opacity: 0
          }
        } else {
          areaStyle = {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0.2,
                color: this.lineList.list.areaColor[i].start
              }, {
                offset: 0.9,
                color: this.lineList.list.areaColor[i].end
              }], false),
              shadowColor: 'rgba(95, 92, 44, 1)',
              shadowBlur: 1,
              shadowOffsetY: 10
            }
          }
        }
        item = {
          type: 'line',
          showSymbol: this.lineList.list.showSymbol[i],
          symbol: 'circle',
          name: this.lineList.list.name[i],
          lineStyle: {normal: {width: this.lineList.lineWidth || 2.5, color: this.lineList.list.lineColor[i]}},
          areaStyle: areaStyle,
          itemStyle: {
            color: this.lineList.list.lineColor[i] || '#fff000',
            borderColor: this.lineList.borderColor || '#092444',
            borderWidth: 2,
            lineStyle: {
              type: 'solid',
              color: '#fff000',
              width: 2
            }
          },
          smooth: this.lineList.smooth || false,
          symbolSize: this.lineList.symbolSize || 6,
          data: this.lineList.list.data[i],
          animationDuration: 4000,
          animationDurationUpdate: 400,
          animationEasing: 'cubicIn',
          animationDelay: function (idx) {
            return idx * 280 + 100
          }
        }
        series.push(item)
      }
      for (let i = 0; i < this.lineList.list.name.length; i++) {
        nameList.push(this.lineList.list.name[i])
      }
      let legend = {}
      switch (this.position) {
        case 'top':
          legend = {
            top: 0,
            data: nameList,
            textStyle: {
              fontSize: 12,
              color: '#068ddb'
            }
          }
          break
        case 'bottom':
          legend = {
            bottom: '0px',
            data: nameList,
            icon: 'line',
            textStyle: {
              fontSize: 12,
              color: '#00c0ff'
            }
          }
          break
        case 'left':
          legend = {
            left: 0,
            data: nameList,
            textStyle: {
              fontSize: 12,
              color: '#068ddb'
            }
          }
          break
        case 'right':
          legend = {
            right: 0,
            data: nameList,
            textStyle: {
              fontSize: 12,
              color: '#068ddb'
            }
          }
          break
        default:
          legend = {
            show: false
          }
          break
      }
      // if (this.lineList.toolTipFormatter === false) {
      //   formatter = ''
      // } else {
      //   let arr = []
      //   this.lineList.list.data.map(v => {
      //     if (v.length > 0) {
      //       arr.push(v)
      //     }
      //   })
      //   let tmp = arr.map((v, i) => {
      //     let a = 'a' + i
      //     let c = 'c' + i
      //     return '<span style="color: #00c0ff; font-size: 12px">{' + a + '}</span>： <span style="color: #addbff; font-size: 12px">{' + c + '}' + this.lineList.yName +
      //       '</span><br />'
      //   })
      //   formatter = '<span style="color: #00f17d; font-size: 15px">' + year + '{b}</span><br />' + tmp
      //   formatter = formatter.replace(/,/g, '')
      // }
      const _dataList = this.lineList.list.data.filter(v => v.length > 0)
      let tooltip = {
        trigger: 'axis',
        axisPointer: {
          lineStyle: {
            color: 'rgba(95, 92, 44, 0)'
          }
        },
        textStyle: {
          align: 'left'
        },
        backgroundColor: 'rgba(0, 0, 0, 0.55)',
        borderColor: '#155a8d',
        borderWidth: 1,
        formatter: this.getFormatter(_dataList)
      }
      let option = {
        tooltip: tooltip,
        legend: legend,
        grid: {
          left: this.lineList.grid.left || '10%',
          right: this.lineList.grid.right || '4%',
          bottom: this.lineList.grid.bottom || '15%',
          top: this.lineList.grid.top || '20%',
          containLabel: true,
          y2: 50
        },
        xAxis: [{
          type: 'category',
          boundaryGap: this.lineList.boundaryGap || false,
          axisLine: {
            lineStyle: {
              color: '#0061cf'
            }
          },
          axisTick: {
            show: false
          },
          data: this.lineList.xData,
          axisLabel: {
            interval: 0,
            rotate: this.lineList.rotate || 0,//横坐标字体倾斜
            textStyle: {
              fontSize: 12,
              color: '#00c0ff'
            }
          }
        }],
        yAxis: [{
          type: 'value',
          name: '单位：' + this.lineList.yName,
          nameTextStyle: {
            color: '#00c0ff',
            fontSize: 13,
            padding: this.lineList.padding || [0, 4, 5, 30]
          },
          minInterval: this.lineList.minInterval,
          interval: this.lineList.interval,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#0061cf'
            }
          },
          axisLabel: {
            textStyle: {
              fontSize: 13,
              color: '#0881c7'
            }
          },
          splitLine: {
            show: this.lineList.splitLine || false,
            lineStyle: {
              color: '#163b5d'
            }
          }
        }],
        series: series
      }
      this.myLine.setOption(option)
      // window.addEventListener('resize', this.resizeEvent)
      /**
       * @Description:折线tooltip添加点击事件
       * @author wanghongling
       * @createDate 2019/9/24
       */
      this.myLine.on('legendselectchanged', params  => {
        this.selectValue = Object.values(params.selected).filter(val => val === true)
        option.tooltip.formatter = this.getFormatter(this.selectValue)
        this.myLine.setOption(option)
      })
    },
    /**
     * 获取tooltip 提示格式
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2021/7/2
     * @param arr
     * @return {string}
     */
    getFormatter(arr) {
      let formatter
      let year = this.lineList.year ? this.lineList.year + '-' : ''
      switch (this.lineList.toolTipFormatter) {
        case '01': {
          let tmp = arr.map((v, i) => {
            let a = 'a' + i
            let c = 'c' + i
            return (
                '<span style="color: #00c0ff; font-size: 12px">{' +
                a +
                '}</span>： <span style="color: #addbff; font-size: 12px">{' +
                c +
                '}' +
                this.lineList.yName +
                '</span><br />'
            )
          })
          formatter = '<span style="color: #00f17d; font-size: 15px">' + year + '{b}</span><br />' + tmp
          break
        }
        case '02': {
          let tmp1 = arr.map((v, i) => {
            let a = 'a' + i
            let c = 'c' + i
            return (
                '<span style="color: #fff; font-size: 14px">{' + a + '}</span>： <span style="color: #fff; font-size: 14px">{' + c + '}' + this.lineList.yName + '</span><br />'
            )
          })
          formatter = '<span style="color: #fff; font-size: 15px">' + year + '{b}月</span><br />' + tmp1
          break
        }
        default:
          formatter = ''
          break
      }
      return formatter.replace(/,/g, '')
    },
    /**
     * echart图表适应
     * @author: whl
     * @createDate: 2019/8/9
     * @return {Object}
     */
    resizeEvent() {
      this.myLine.resize() // 使图表适应
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/echarts/line.vue